import { UsersListLoading } from "../../Reviews/Review/users-list/components/loading/UsersListLoading";
import { KTCardBody } from "../../../../_metronic/helpers";
import { Pagination } from "../../../../components/Pagination";
import { formatPrice, extractReservationNumber } from "../../../../_metronic/helpers/utils";
import { Link } from "react-router-dom";
import moment from "moment";

const headers = [
  { title: 'Date', width: '180px', sort_key: 'created_at' },
  { title: 'Customer Name', width: '150px' },
  { title: 'Transactions', width: '170px', sort_key: 'amount' },
  { title: 'Reservation Number/Remarks', width: '150px' },
  { title: 'Charge ID/Notes', width: '240px', className: 'text-end' },
]

const sortMap = [
  {
    id: 1,
    key: 'created_at',
    order: 'desc'
  },
  {
    id: 2,
    key: 'created_at',
    order: 'asc'
  },
  {
    id: 3,
    key: 'amount',
    order: 'desc'
  },
  {
    id: 4,
    key: 'amount',
    order: 'asc'
  }
]



const renderRemarks = (row) => {
  if (row.type === 'CR') {
    if (row.trans_type === 'topup') {
      return (
        <a href={`https://dashboard.stripe.com/payments/${row.remarks}`} target='_blank'>
          {row.remarks || '-'}
        </a>
      );
    } else if (row.trans_type === 'reward') {
      return 'Bonus Credited';
    } else if (row.trans_type === 'club cash') {
       return (
        <Link to={`/bookings?search_type=reservation_code&search=${extractReservationNumber(row.remarks)}`}>
          {row.remarks || '-'}
        </Link>
      );
    }
  }

  if (row.type === 'DR' && row.notes) {
    return row.notes || 'Booking';
  }

  return row.remarks || 'N/A';
};


export const WalletLogsTable = ({ walletData, isLoading, page, setPage, pageSize, setPageSize, setSort, sort, getConsumptionType, getTransactionType }) => {

const sortColumn = (key) => {
    const nextOrder = sort.order === 'desc' && sort.key === key ? 'asc' : 'desc';
    const nextSort = sortMap.find(s => s.key === key && s.order === nextOrder);

    if (nextSort) {
      setSort(nextSort);
    }
  };


  return (
    <KTCardBody className='py-4'>
      <h6 style={{ color: '#7e8299', textAlign: 'right' }}>Total: {walletData?.total || 0} </h6>
      <div className='table-responsive mb-4'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map(column => {
                const isSorted = column.sort_key === sort.key;
                const orderClass = isSorted ? `table-sort-${sort.order}` : 'table-sort';
                return (<th
                  key={column.title}
                  className={`${orderClass} ${column.className ? column.className : ''} ${column.sort_key ? 'pointer' : ''}`}
                  style={{ minWidth: column.width }}
                  onClick={() => column.sort_key && sortColumn(column.sort_key)}
                >
                  {column.title}
                </th>
              )
              })}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold'>
            {walletData?.data?.length > 0 && (
              walletData?.data.map(row => (
                <tr key={row.arrear_id}>
                  <td style={{ minWidth: headers[0].width }}>{(moment(row.created_at).utc().format('MMM DD, YYYY h:mm A'))}</td>
                  <td style={{ minWidth: headers[1].width }}><Link to={`/users/${row.uid}`}>{row.first_name} {row.last_name}</Link></td>
                  <td style={{ minWidth: headers[2].width, color: row.type === 'CR' ? row.status === 0 ? '#ffaa00' : '#2ecc71' : '#ed2626' }}> {row.type === 'CR' ? `+${formatPrice(Math.abs(row.amount))}` : `-${formatPrice(Math.abs(row.amount))}`} {row.trans_type === 'review' && '(Review)'} {row.status === 0 && <i className="fas fa-clock" style={{color: '#ffaa00'}} />}</td>
                  <td style={{ minWidth: headers[3].width }}
                  >
                    {row.type === 'CR' ? getTransactionType(row.trans_type) 
                    : 
                    row.type === 'DR' && row.remarks ? <Link to={`/bookings?search_type=reservation_code&search=${extractReservationNumber(row.remarks)}`}>{`${row.remarks} ${getConsumptionType(row.trans_type) !== 'Club Cash Revert' ? `(${getConsumptionType(row.trans_type)})` : ''}`}</Link>
                    : 'Admin Deducted Funds'
                    }
                  </td>
                  <td style={{ width: headers[4].width, textAlign: 'end', paddingRight: '20px' }}>
                    {renderRemarks(row)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        {walletData?.data && !walletData?.data?.length > 0 &&
          <div className='d-flex text-center text-gray-600 fw-bolder fs-6 w-100 align-content-center justify-content-center mt-10'>
            No matching records found
          </div>
        }
      </div>
      <Pagination
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        total={walletData?.total || 0}
         pageSizeOptions={[50, 100, 200, 500]}
      />
      {isLoading && <UsersListLoading />}
    </KTCardBody>
  );
};
